import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useCallback, useEffect } from "react";
import { ModalLoading } from "../../../../../../common/components/modal_loading";
import FormContainer from "../../../../../../common/components/form_container";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { DropDown } from "../../../../../../common/domain/models/dropdown";
import { FormRadioGroupInput } from "../../../../../../common/components/masked_inputs/react_forms/form_radio_group_input";
import { DefaultFormAutocomplete } from "../../../../../../common/components/default_form_autocomplete";
import { FormDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import { defaultReajusteContratoIndividualForm, ReajusteContratoIndividualForm, ReajusteContratoIndividualSchema } from "../../../schemas/ContratoFinanceiro_cadastro/ReajusteContratoIndividual_form";

/**
 * Reajuste individual Cadastro Modal 
 */

type Props = {
    open: boolean,
    saving: boolean,
    idContratoFinanceiro: number,
    idIndiceReajuste: number,
    // hookForm: UseFormReturn<ReajusteContratoIndividualForm>,
    ddlIndiceReajuste: DropDown[],

    onSubmit: (form: ReajusteContratoIndividualForm) => void,
    onClose: () => void,
};

export const CadastroReajusteIndividualModal = ({
    open,
    saving,
    ddlIndiceReajuste,
    idContratoFinanceiro,
    idIndiceReajuste,
    onSubmit,
    onClose,

}: Props) => {

    const hookForm = useForm<ReajusteContratoIndividualForm>({
        mode: "onSubmit",
        reValidateMode: "onSubmit",
        defaultValues: defaultReajusteContratoIndividualForm,
        resolver: zodResolver(ReajusteContratoIndividualSchema),
    });

    const handleSubmit = useCallback((form: ReajusteContratoIndividualForm) => {
        if (!saving) {
            onSubmit(form);
        }
    }, [saving, onSubmit]);

    const handleClose = useCallback(() => {
        if (!saving) {
            onClose();
        }
    }, [saving, onClose]);


    useEffect(() => {
        hookForm.setValue('idContratoFinanceiro', idContratoFinanceiro);
        hookForm.setValue('idIndiceReajuste', idIndiceReajuste);
        hookForm.setValue('aplicarNaEntrada', 0);

    }, [idContratoFinanceiro, idIndiceReajuste, hookForm]);

    return (
        <Dialog
            open={open}
            slotProps={{
                paper: {
                    component: 'form',
                    onSubmit: hookForm.handleSubmit(handleSubmit),
                }
            }}
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "55rem",
                    },
                },
            }}>

            <DialogTitle>
                Cadastrar Reajuste Individual no contrato
            </DialogTitle>

            <DialogContent>
                <ModalLoading loading={saving}>
                    <FormContainer title={"Informações"} arrangement="fullRow">
                        <div className="w-full bg-white p-4  rounded-2xl shadow-sm space-y-3">
                            <div className="flex flex-row gap-4 w-full justify-between">
                                <div className="w-[40%]">
                                    <DefaultFormAutocomplete
                                        name="idIndiceReajuste"
                                        label="Indice de Reajuste"
                                        required={true}
                                        readOnly={true}
                                        options={ddlIndiceReajuste}
                                        getOptionLabel={x => x.title}
                                        getOptionKey={x => x.id}
                                        reactHookForm={hookForm} />
                                </div>
                            </div>

                            {/* <div className="flex flex-row gap-4 w-full justify-between">
                                <FormDatePickerInput
                                    name='dataInicioAplicacaoReajuste'
                                    label='Data início aplicação reajuste'
                                    required={false}
                                    readOnly={false}
                                    reactHookForm={hookForm}
                                />
                            </div> */}

                            <div>
                                <div className="flex flex-row gap-4 w-full justify-between">
                                    <label className="font-medium text-gray-700 ">Data de aplicação dos reajustes</label>
                                </div>
                                <div className="flex flex-row gap-4 w-full m-2">
                                    <FormDatePickerInput
                                        name='dataReajusteDe'
                                        label='Data do reajuste'
                                        tipoData="mes"
                                        required={true}
                                        readOnly={false}
                                        reactHookForm={hookForm}
                                    />

                                    {/* <FormDatePickerInput
                                        name='dataReajusteAte'
                                        label='Data reajuste até'
                                        tipoData="mes"
                                        required={false}
                                        readOnly={false}
                                        reactHookForm={hookForm}
                                    /> */}

                                </div>
                            </div>

                            <div className="flex items-center justify-between">
                                <label className="font-medium text-gray-700 mb-2 ">Aplicar reajuste na entrada dos contratos?</label>
                                <FormRadioGroupInput
                                    name="aplicarNaEntrada"
                                    label=""
                                    readOnly={saving}
                                    options={[
                                        { id: 1, label: "Sim" },
                                        { id: 0, label: "Não" },
                                    ]}
                                    reactHookForm={hookForm}
                                />
                            </div>

                        </div>
                    </FormContainer>
                </ModalLoading>
            </DialogContent>

            <DialogActions>
                <div className="w-full flex items-end justify-between px-4 pb-4 gap-4">
                    <div className="flex-grow" />
                    <div className="flex flex-row gap-2">
                        <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                            <h1
                                className="text-sm text-black dark:text-white"
                                onClick={handleClose}>
                                Cancelar
                            </h1>
                        </div>

                        <div className="w-[120px]">
                            {saving ? (
                                <PrimaryButton
                                    buttonColor="primary-green">
                                    Salvando...
                                </PrimaryButton>
                            ) : (
                                <PrimaryButton
                                    type="submit"
                                    buttonColor="primary-green">
                                    Salvar
                                </PrimaryButton>
                            )}
                        </div>
                    </div>
                </div>
            </DialogActions>
        </Dialog >

    );
}